import { render, staticRenderFns } from "./hsw.vue?vue&type=template&id=6bf36961&scoped=true&"
var script = {}
import style0 from "./hsw.vue?vue&type=style&index=0&id=6bf36961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf36961",
  null
  
)

export default component.exports